import React, { useState } from 'react';

const Letters = () => {
        const [activeTab, setActiveTab] = useState('All');
        const [currentPage, setCurrentPage] = useState(1);
        const itemsPerPage = 10;

        // Sample data structure
        const lettersData = [
                {
                        provider: 'Paul Verrils',
                        patient: 'Kerryn Casey',
                        to: 'Alex Alashkevich',
                        cc: '',
                        dateCreated: '07 August 2024',
                        lastUpdated: '07 August 2024',
                        status: 'Draft',
                        attachments: 2
                },
                {
                        provider: 'Paul Verrils',
                        patient: 'Barbara Rawson',
                        to: 'Yoke Foo',
                        cc: '',
                        dateCreated: '28 June 2024',
                        lastUpdated: '28 June 2024',
                        status: 'Draft',
                        attachments: 0
                },
                {
                        provider: 'Paul Verrils',
                        patient: 'John Hayes',
                        to: 'Greg Malham',
                        cc: 'Chris Kozlovski',
                        dateCreated: '17 June 2024',
                        lastUpdated: '17 June 2024',
                        status: 'Signed',
                        attachments: 3
                }
        ];

        const tabs = [
                { id: 'All', label: 'All' },
                { id: 'ToCreate', label: 'To Create' },
                { id: 'ToReview', label: 'To Review' },
                { id: 'Signed', label: 'Signed', count: 1 },
                { id: 'Sent', label: 'Sent' }
        ];

        return (
                <div className="p-6 bg-white rounded-lg shadow">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-6">
                                <h1 className="text-2xl font-semibold">Letters • all</h1>
                        </div>

                        {/* Search and Filter Section */}
                        <div className="mb-6 flex items-center space-x-4">
                                <div className="relative">
                                        <input
                                                type="text"
                                                placeholder="Type the letter to be searched"
                                                className="w-64 px-4 py-2 border rounded-md"
                                        />
                                </div>
                                <select className="px-4 py-2 border rounded-md">
                                        <option value="">Provider</option>
                                </select>
                                <button className="bg-cyan-500 text-white px-4 py-2 rounded-md">
                                        Search
                                </button>
                        </div>

                        {/* Tabs */}
                        <div className="border-b mb-6">
                                <div className="flex space-x-8">
                                        {tabs.map((tab) => (
                                                <button
                                                        key={tab.id}
                                                        className={`pb-2 px-1 ${activeTab === tab.id
                                                                ? 'border-b-2 border-blue-500 text-blue-500'
                                                                : 'text-gray-500'
                                                                }`}
                                                        onClick={() => setActiveTab(tab.id)}
                                                >
                                                        {tab.label}
                                                        {tab.count && (
                                                                <span className="ml-1 bg-blue-500 text-white rounded-full px-2 py-0.5 text-xs">
                                                                        {tab.count}
                                                                </span>
                                                        )}
                                                </button>
                                        ))}
                                </div>
                        </div>

                        {/* Table */}
                        <div className="overflow-x-auto">
                                <table className="w-full">
                                        <thead>
                                                <tr className="border-b">
                                                        <th className="text-left py-3 px-4">Provider</th>
                                                        <th className="text-left py-3 px-4">Patient</th>
                                                        <th className="text-left py-3 px-4">To</th>
                                                        <th className="text-left py-3 px-4">CC</th>
                                                        <th className="text-left py-3 px-4">Date Created</th>
                                                        <th className="text-left py-3 px-4">Last Updated</th>
                                                        <th className="text-left py-3 px-4"># Attachments</th>
                                                        <th className="text-left py-3 px-4">Status</th>
                                                        <th className="text-left py-3 px-4">Actions</th>
                                                </tr>
                                        </thead>
                                        <tbody>
                                                {lettersData.map((letter, index) => (
                                                        <tr
                                                                key={index}
                                                                className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}
                                                        >
                                                                <td className="py-3 px-4">{letter.provider}</td>
                                                                <td className="py-3 px-4">{letter.patient}</td>
                                                                <td className="py-3 px-4">{letter.to}</td>
                                                                <td className="py-3 px-4">{letter.cc}</td>
                                                                <td className="py-3 px-4">{letter.dateCreated}</td>
                                                                <td className="py-3 px-4">{letter.lastUpdated}</td>
                                                                <td className="py-3 px-4">
                                                                        <span className="inline-flex items-center">
                                                                                📎 {letter.attachments}
                                                                        </span>
                                                                </td>
                                                                <td className="py-3 px-4">
                                                                        <span
                                                                                className={`px-3 py-1 rounded-full text-sm ${letter.status === 'Signed'
                                                                                        ? 'bg-green-100 text-green-800'
                                                                                        : 'bg-purple-100 text-purple-800'
                                                                                        }`}
                                                                        >
                                                                                {letter.status}
                                                                        </span>
                                                                </td>
                                                                <td className="py-3 px-4">
                                                                        <div className="flex space-x-2">
                                                                                {letter.status === 'Signed' ? (
                                                                                        <>
                                                                                                <button className="p-1 hover:bg-gray-100 rounded">⬇️</button>
                                                                                                <button className="p-1 hover:bg-gray-100 rounded">🖨️</button>
                                                                                                <button className="p-1 hover:bg-gray-100 rounded">✅</button>
                                                                                        </>
                                                                                ) : (
                                                                                        <button className="p-1 hover:bg-gray-100 rounded">✏️</button>
                                                                                )}
                                                                        </div>
                                                                </td>
                                                        </tr>
                                                ))}
                                        </tbody>
                                </table>
                        </div>

                        {/* Pagination */}
                        <div className="flex items-center justify-between mt-4 text-sm">
                                <div className="flex items-center space-x-2">
                                        <span>Start</span>
                                        <button
                                                className="px-2 py-1 border rounded"
                                                disabled={currentPage === 1}
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                        >
                                                Previous
                                        </button>
                                        <span>Page {currentPage} of 3</span>
                                        <button
                                                className="px-2 py-1 border rounded"
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                        >
                                                Next
                                        </button>
                                        <span>End</span>
                                </div>
                                <div className="flex items-center space-x-2">
                                        <span>Items per page</span>
                                        <select className="border rounded px-2 py-1">
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                        </select>
                                </div>
                        </div>
                </div>
        );
};

export default Letters;